module.exports = __webpack_public_path__ + "img/scrollingBox.382a8802.gif";